import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const commissionService = {
  getAllRates, createRate, updateRate, deleteRate,
  getAllRecords, getRecordSummary, batchUpdateStatus,
}

const API_URL = API.BASE_URL + '/v1'

function buildRecordParams(filter) {
  const params = { per_page: filter?.pageSize, page: filter?.pageNumber }
  if (filter?.agentCode) params.agent_code = filter.agentCode
  if (filter?.periodMonth) params.period_month = filter.periodMonth
  if (filter?.status) params.status = filter.status
  if (filter?.dateFrom) params.date_from = filter.dateFrom
  if (filter?.dateTo) params.date_to = filter.dateTo
  return params
}

// Rates
export function getAllRates(filter) {
  const params = {}
  if (filter?.agentCode) params.agent_code = filter.agentCode
  return apiHelper(API_URL).get('/commission-rates', { params })
}
export function createRate(data) {
  return apiHelper(API_URL).post('/commission-rates', data)
}
export function updateRate(id, data) {
  return apiHelper(API_URL).put(`/commission-rates/${id}`, data)
}
export function deleteRate(id) {
  return apiHelper(API_URL).delete(`/commission-rates/${id}`)
}

// Records
export function getAllRecords(filter) {
  return apiHelper(API_URL).get('/commission-records', { params: buildRecordParams(filter) })
}
export function getRecordSummary(filter) {
  return apiHelper(API_URL).get('/commission-records/summary', { params: buildRecordParams(filter) })
}
export function batchUpdateStatus(data) {
  return apiHelper(API_URL).patch('/commission-records/batch-status', data)
}
